<template>
  <div class="additional-form">
    <div class="create-contract">
      <el-row :gutter="24" class="header">
        <el-col :span="12">
          <b>Номер документа </b>
        </el-col>
        <el-col :span="12" class="text-align-right">
          <b>Аткуальный договор</b>
        </el-col>
      </el-row>
      <el-row
        v-if="!contracts.length"
        class="no-contracts"
        :gutter="24"
        align="middle"
        type="flex"
      >
        <el-col :span="10">
          <b class="text">Нет договора с контрагентом</b>
        </el-col>
        <el-col :span="10">
          <el-button plain type="primary" @click="createContractHandler">
            Создать
          </el-button>
        </el-col>
      </el-row>
      <el-row v-else :gutter="24" type="flex" align="middle">
        <el-col :span="6">
          <el-input
            v-model="returnData.number"
            class="number-document"
            placeholder="Введите номер документа"
            :readonly="isApprove"
          />
        </el-col>
        <el-col :span="10" class="wrap-save">
          <el-button
            v-if="!isApprove"
            class="save"
            type="primary"
            plain
            @click="changed"
          >
            Сохранить
          </el-button>
        </el-col>
        <el-col :span="8" class="text-align-right">
          <a
            class="create-new-contract"
            href="#"
            @click.prevent="createContractHandler()"
          >
            Создать новый договор
          </a>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <a href="#" class="move-to-files" @click.prevent="showFileList">
            Перейти к файлам
          </a>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { pickerOpt } from '@/datas/consts'

export default {
  name: 'AdditionalsForm',
  props: {
    document: {
      type: Object,
      default: () => {},
    },
    contracts: {
      type: Array,
      default: () => [],
    },
    documentId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      unlim: true,
      pickerOpt,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now()
        },
      },
      returnData: {
        number: '',
        expire_at: '',
        document_create_date: null,
      },
    }
  },
  computed: {
    isApprove() {
      return this.document.approve_status > 0
    },
    isWithDate() {
      // TODO сделать для всех доков так
      return this.document.document_type_id === 27
    },
  },
  watch: {
    documentId: {
      immediate: true,
      handler() {
        this.setDataForEdit()
      },
    },
  },
  methods: {
    createContractHandler() {
      this.$emit('createContract')
    },
    setDataForEdit() {
      const { number, document_create_date, expire_at } = this.document

      this.returnData.number = number

      if (this.isWithDate) {
        this.returnData.document_create_date = document_create_date
      }
      this.returnData.expire_at = expire_at
      this.unlim = !this.returnData.expire_at
    },
    changed() {
      // TODO валидация формы
      this.$emit('changed', this.returnData)
    },
    showFileList() {
      this.$emit('showFileList')
    },
  },
}
</script>

<style lang="sass">
.additional-form
  border: 2px dashed #ddd
  padding: 0 10px 10px
  margin-top: 10px
.create-contract
  & .header
    & b
      padding: 10px 10px 0 10px
      display: block
      &:first-child
        padding-left: 0
      &:last-child
        padding-right: 0
  & .no-contracts
    height: 120px
    & .text
      text-transform: uppercase
      font-weight: 500
  & .text-align-right
    text-align: right
  & .el-date-editor.el-input
    width: 100%
  & a.create-new-contract
    color: #FF0000
    text-decoration: underline
  & .move-to-files
    color: #3498DB
    text-decoration: underline
  & .number-document
    margin: 20px 0
</style>
